import React from 'react'

import Logo from '../../../components/layout/Logo/Logo'
import { PageHeader, HeaderInner, HeaderLogo } from './HeaderStyledComponents'

const Header = () => (
  <PageHeader>
    <HeaderInner>
      <HeaderLogo>
        <Logo />
      </HeaderLogo>
    </HeaderInner>
  </PageHeader>
)

Header.displayName = 'Header'

export default Header
